(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-toast"] && !Shopify.designMode) return;
  try {
    (() => {
    const toast = document.getElementById('cart-toast');
    if (!toast) return;

    const image = toast.querySelector('.cart-toast__image');
    const title = toast.querySelector('.cart-toast__title');
    let hideTimer;

    document.addEventListener('cart-add-success', (event) => {
      const detail = event.detail || {};
      title.textContent = detail.title || '';

      if (detail.image) {
        image.src = detail.image;
        image.classList.remove('is-hidden');
      } else {
        image.removeAttribute('src');
        image.classList.add('is-hidden');
      }

      toast.hidden = false;
      requestAnimationFrame(() => toast.classList.add('is-visible'));

      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        toast.classList.remove('is-visible');
        setTimeout(() => {
          toast.hidden = true;
        }, 250);
      }, 3000);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-add-to-cart')) {
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.target = document.querySelector(this.dataset.target);
        this.button = this.querySelector('[data-sticky-atc]');
        this.label = this.querySelector('[data-sticky-label]');
        this.price = this.querySelector('[data-sticky-price]');
        this.loader = this.querySelector('.loader');
        this.onClick = this.onClick.bind(this);
        this.onIntersect = this.onIntersect.bind(this);
        this.sync = this.sync.bind(this);

        if (!this.target || !this.button) return;

        this.button.addEventListener('click', this.onClick);
        document.addEventListener('variant-change', this.sync);
        document.addEventListener('cart-add-success', this.sync);

        this.observer = new IntersectionObserver(this.onIntersect, {
          threshold: 0,
          rootMargin: '0px'
        });
        this.observer.observe(this.target);

        this.mutator = new MutationObserver(this.sync);
        this.mutator.observe(this.target, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled']
        });

        this.cartDrawer = document.getElementById('cart_sidebar');
        if (this.cartDrawer) {
          this.cartMutator = new MutationObserver(() => this.updateVisibility());
          this.cartMutator.observe(this.cartDrawer, {
            attributes: true,
            attributeFilter: ['class', 'aria-hidden']
          });
        }

        this.buyButtonVisible = true;
        this.sync();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        document.removeEventListener('variant-change', this.sync);
        document.removeEventListener('cart-add-success', this.sync);
        this.observer?.disconnect();
        this.mutator?.disconnect();
        this.cartMutator?.disconnect();
      }

      sourceButton() {
        return this.target?.querySelector('.product_form_buy_button');
      }

      onIntersect(entries) {
        const entry = entries[0];
        this.buyButtonVisible = Boolean(entry) && entry.isIntersecting;
        this.updateVisibility();
      }

      cartIsOpen() {
        const cart = this.cartDrawer || document.getElementById('cart_sidebar');
        if (!cart) return false;
        return cart.classList.contains('cart-sidebar-open') || cart.classList.contains('is-open') || cart.getAttribute('aria-hidden') === 'false';
      }

      updateVisibility() {
        this.toggle(!this.buyButtonVisible && !this.cartIsOpen());
      }

      toggle(show) {
        this.hidden = !show;
        this.classList.toggle('is-visible', show);
        document.body.classList.toggle('has-sticky-atc', show);
        if (show) {
          document.body.style.setProperty('--sticky-atc-offset', `${this.offsetHeight}px`);
        } else {
          document.body.style.removeProperty('--sticky-atc-offset');
        }
      }

      sync() {
        window.requestAnimationFrame(() => {
          const source = this.sourceButton();
          if (!source) return;

          const sourceLabel = source.querySelector('.atc_status');
          const sourceLoader = source.querySelector('.loader');
          const priceEl = document.querySelector(`#Price-${this.sectionId} .product_block_price`);

          if (sourceLabel && this.label) {
            this.label.textContent = sourceLabel.textContent.trim();
          }
          if (priceEl && this.price) {
            this.price.textContent = priceEl.textContent.trim();
          }

          this.button.disabled = source.disabled;
          const loading = sourceLoader && !sourceLoader.classList.contains('hidden');
          this.label.style.visibility = loading ? 'hidden' : 'visible';
          this.loader.classList.toggle('hidden', !loading);
        });
      }

      onClick() {
        const form = this.target.querySelector('form');
        if (!form || this.button.disabled) return;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          this.sourceButton()?.click();
        }
      }
    }

    customElements.define('sticky-add-to-cart', StickyAddToCart);
  }
  } catch(e) { console.error(e); }
})();

})();
